@if (featureSet.selected) {
  <div (click)="clicked()" matTooltip="{{featureSet.name}}" matTooltipClass="lightwave-tooltip" [class]="featureSet.selected? 'device-container active flex-even mx-2' : 'device-container flex-even mx-2'">
    <div class="icon-container">
      <i class="{{ icons.getIcon(featureSet.productCode) }}" [style.margin-left]="margin"></i>
    </div>
    <div class="title-text">
      {{featureSet.displayName}}
    </div>
  </div>
}
